import { EGetUserStatus } from '../../actions/user';
import { TReduxActions } from '../../types/redux';
import { TUser } from '../../types/newbuilding/currentUser';

const defaultState: TUser = {
  isAuthenticated: false,
};

export function userReducer(state: TUser = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EGetUserStatus.Succeed: {
      return {
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
